<div *ngIf="!has_error" #content>
	<!--  DEALER HEADER  -->

	<ui-dealer-header [location]="'engage_authenticate'" #header></ui-dealer-header>

	<!-- END DEALER HEADER  -->

	<!--  HEADING  -->

	<div class="heading">
		<h3>We need to check you're you!</h3>
		<p>
			For us to confirm your identity we need to send you an access code. Please choose where you want us to send
			it and once you've got it, enter it below to gain access.
		</p>
	</div>

	<!--  END HEADING  -->

	<!--  CONTACT METHODS  -->

	<ul class="key-value-list striped alt-style">
		<li>
			<div class="key">Email: {{ customer_email }}</div>
			<div class="value">
				<button
					type="button"
					class="button small-button pri-fg pri-bg"
					[class.loading]="email_sending"
					[class.disabled]="email_disabled"
					[attr.disabled]="email_disabled ? 'disabled' : null"
					(click)="sendAccessCode('email')"
				>
					<span class="loading-spinner"></span>
					Send Code
				</button>
			</div>
		</li>
		<li *ngIf="customer_sms">
			<div class="key">SMS: {{ customer_sms }}</div>
			<div class="value">
				<button
					type="button"
					class="button small-button pri-fg pri-bg"
					[class.loading]="sms_sending"
					[class.disabled]="sms_disabled"
					[disabled]="sms_disabled ? 'disabled' : null"
					(click)="sendAccessCode('sms')"
				>
					<span class="loading-spinner"></span>
					Send Code
				</button>
			</div>
		</li>
	</ul>

	<!--  END CONTACT METHODS  -->

	<!--  ACCESS CODE FORM  -->

	<form [formGroup]="auth_form" (submit)="onSubmit()" novalidate autocomplete="off">
		<div class="row">
			<div class="col-xxs-30">
				<ui-text-control
					[form]="auth_form"
					[form_control]="auth_form.controls['access_code']"
					[type]="'number'"
					[placeholder]="'Enter your access code...'"
				></ui-text-control>
			</div>
		</div>
		<div class="button-container">
			<button class="button large-button block-button positive-button" [class.loading]="verifying">
				<span class="loading-spinner"></span>
				Verify
			</button>
		</div>
	</form>

	<!--  END ACCESS CODE FORM  -->

	<!--  NOT YOU  -->

	<div *ngIf="!!vehicle_in_storage_id && can_start_again" class="heading not-you">
		<h4>Not you?</h4>
		<p>
			If these details don't look like yours, please
			<a class="text-hl" (click)="onStartAgain()"><strong>Click Here</strong></a>
			to remove this session and start again.
		</p>
	</div>

	<!--  END NOT YOU  -->
</div>
